import { useEffect, useState } from "react";
import { SystemCheckConfigurations } from "../components/layout/system-check-steps/system-check-steps";

export enum SystemCheckStepperEnum {
  SystemCompatibility = "systemCompatibility",
  Screen = "screen",
  Webcam = "webcam",
  Microphone = "microphone",
  Network = "network",
  Summary = "summary",
}

export interface SystemCheckStepper {
  name: SystemCheckStepperEnum;
  i18nId: string;
  FAQLink?: string;
}

export const SystemCheckSteppers: SystemCheckStepper[] = [
  {
    name: SystemCheckStepperEnum.SystemCompatibility,
    i18nId: 'SYSTEM_CHECK_STEPPER.SYSTEM',
    FAQLink: process.env.REACT_APP_SYSTEM_COMPATIBILITY_FAQ,
  },
  {
    name: SystemCheckStepperEnum.Screen,
    i18nId: 'SYSTEM_CHECK_STEPPER.SCREEN',
    FAQLink: process.env.REACT_APP_SCREEN_RESOLUTION_FAQ,
  },
  {
    name: SystemCheckStepperEnum.Webcam,
    i18nId: 'SYSTEM_CHECK_STEPPER.WEBCAM.TITLE',
    FAQLink: process.env.REACT_APP_WEBCAM_FAQ,
  },
  {
    name: SystemCheckStepperEnum.Microphone,
    i18nId: 'SYSTEM_CHECK_STEPPER.MICROPHONE.TITLE',
    FAQLink: process.env.REACT_APP_MICROPHONE_FAQ,
  },
  {
    name: SystemCheckStepperEnum.Network,
    i18nId: 'SYSTEM_CHECK_STEPPER.NETWORK',
    FAQLink: process.env.REACT_APP_NETWORK_FAQ,
  },
  {
    name: SystemCheckStepperEnum.Summary,
    i18nId: 'SYSTEM_CHECK_STEPPER.SUMMARY'
  },
];

function useSystemCheckSteps(
  configurations: SystemCheckConfigurations,
): SystemCheckStepper[] {
  const [systemCheckSteps, setSystemCheckSteps] = useState<
    SystemCheckStepper[]
  >([]);

  const filterStepperSteps = (
    configurations?: SystemCheckConfigurations,
  ): SystemCheckStepper[] => {
    let systemCheckSteppers = [...SystemCheckSteppers];

    if (!configurations) return [];

    const {
      operatingSystemCheck,
      browserCheck,
      deviceCheck,
      screenResolutionCheck,
      multipleMonitorCheck,
      webcamCheck,
      microphoneCheck,
      urlCheck,
      networkDownloadCheck,
      networkUploadCheck,
    } = configurations;

    if (
      !browserCheck?.enable &&
      !deviceCheck?.enable &&
      !operatingSystemCheck?.enable
    ) {
      systemCheckSteppers = systemCheckSteppers.filter(
        (step) => step.name !== SystemCheckStepperEnum.SystemCompatibility,
      );
    }

    if (!screenResolutionCheck?.enable && !multipleMonitorCheck?.enable) {
      systemCheckSteppers = systemCheckSteppers.filter(
        (step) => step.name !== SystemCheckStepperEnum.Screen,
      );
    }

    if (!webcamCheck?.enable) {
      systemCheckSteppers = systemCheckSteppers.filter(
        (step) => step.name !== SystemCheckStepperEnum.Webcam,
      );
    }

    if (!microphoneCheck?.enable) {
      systemCheckSteppers = systemCheckSteppers.filter(
        (step) => step.name !== SystemCheckStepperEnum.Microphone,
      );
    }

    if (!urlCheck?.enable && !networkDownloadCheck?.enable && !networkUploadCheck?.enable) {
      systemCheckSteppers = systemCheckSteppers.filter(
        (step) => step.name !== SystemCheckStepperEnum.Network,
      );
    }

    return systemCheckSteppers;
  };

  useEffect(() => {
    setSystemCheckSteps(filterStepperSteps(configurations));
  }, []);

  return systemCheckSteps;
}

export default useSystemCheckSteps;
